/**
 * NotFoundPage - Страница 404
 */

import React from "react";
import { GuestLayout } from "../components/layouts";

const NotFoundPage = () => (
    <GuestLayout>
        <div className="title-container">
            <h1 className="main-title main-title--accent">404</h1>
            <p className="desc-title">Страница не найдена</p>
            <div className="buttons-container buttons-container-center">
                <button className="button-signUp" style={{ width: "auto" }}>
                    <a href="/">НА ГЛАВНУЮ</a>
                </button>
            </div>
        </div>
    </GuestLayout>
);

export default NotFoundPage;
